module.exports = __webpack_public_path__ + "img/transfer2.4e53c6e3.png";